import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'healthCheckEntityId',
                },
                'ent:!health-check:!assessment',
              ],
            },
            'Sections',
          ],
          [
            {
              '=': [
                {
                  '@$': 'healthCheckEntityId',
                },
                'ent:!health-check:!track',
              ],
            },
            'Categories',
          ],
          [
            {
              '=': [
                {
                  '@$': 'healthCheckEntityId',
                },
                'ent:!health-check:!dimension',
              ],
            },
            'Questions',
          ],
          'Health Checks',
        ],
      },
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              filter: {
                '=': [
                  {
                    '@^': 'parent',
                  },
                  {
                    '``': {
                      '@$': 'healthCheckRecordId',
                    },
                  },
                ],
              },
              target: 'dim::!health-check',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      score: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '@': 'score',
                                },
                              },
                              {
                                '#': {
                                  '@': 'score',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      healthCheckEntityId: {
                                        '@_': 'id',
                                      },
                                      healthCheckRecordId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'overview',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                  overflowActions: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'healthCheckEntityId',
                              },
                            },
                            'ent:!health-check:!assessment',
                          ],
                        },
                        {
                          '[]': [
                            {
                              '{}': {
                                icon: 'atn-icon atn-link',
                                action: {
                                  '{}': {
                                    payload: {
                                      '{}': {
                                        goto: {
                                          '{}': {
                                            variables: {
                                              '{}': {
                                                healthCheckEntityId: {
                                                  '@_': 'id',
                                                },
                                                healthCheckRecordId: {
                                                  '@.': '!id',
                                                },
                                              },
                                            },
                                            navigationId: 'details',
                                          },
                                        },
                                      },
                                    },
                                    operation: 'ui.navigate',
                                  },
                                },
                              },
                            },
                          ],
                        },
                      ],
                      null,
                    ],
                  },
                },
              },
              subqueries: {
                score: {
                  target: 'ent:!health-check:!criteria',
                  selection: {
                    '@.': '!score',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'score',
                  direct: {
                    '{}': {
                      name: 'Score',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'descr',
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
